import i18n from "@/i18n";
export const sourceOptions = () => {
    return [
        {
            label: i18n.t("zhiji.portrait.source.ALL"),
            value: "all"
        },
        {
            label: i18n.t("zhiji.portrait.source.SDK"),
            value: "sdk"
        },
        {
            label: i18n.t("zhiji.portrait.source.IDIP"),
            value: "idip"
        },
        {
            label: i18n.t("zhiji.portrait.source.CUSTOM"),
            value: "custom"
        }
    ];
};

export const typeOptions = () => {
    return [
        {
            label: "string",
            value: "string"
        },
        {
            label: "datetime",
            value: "datetime"
        },
        {
            label: "int",
            value: "int"
        },
        {
            label: "uint64",
            value: "uint64"
        },
        {
            label: "uint32",
            value: "uint32"
        },
        {
            label: "uint16",
            value: "uint16"
        },
        {
            label: "int64",
            value: "int64"
        },
        {
            label: "float",
            value: "float"
        },
        {
            label: "ubigint",
            value: "ubigint"
        },
        {
            label: "bigint",
            value: "bigint"
        }
    ];
};
